// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"23dd8b73","515":"2a1555f6","588":"38218529","593":"feec7df0","797":"f38f7606"}[chunkId] + ".chunk.js";
};